import { render, staticRenderFns } from "./courseTitle.vue?vue&type=template&id=b73e5ad2&scoped=true&"
import script from "./courseTitle.vue?vue&type=script&lang=js&"
export * from "./courseTitle.vue?vue&type=script&lang=js&"
import style0 from "./courseTitle.vue?vue&type=style&index=0&id=b73e5ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73e5ad2",
  null
  
)

export default component.exports